import { Directive } from "@angular/core";
import { BaseComponent, UserService } from "@mypxplat/xplat/core";

@Directive()
export abstract class ExchangeDetailBaseComponent extends BaseComponent {
  public text: string = "ExchangeDetail";

  constructor(userService: UserService) {
    super(userService);
  }
}
